import React from 'react';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';

class LazyComponent {
    loaderResource = {
        loading: () => (
            <div className="loading-wrapper">
                <Loader keepOverlay loaderClass="lazy-loader" />
            </div>
        ),
        error: () => null,
        timeout: 60000,
    };
}

export default new LazyComponent();
